import MultiSelectDropdown from "./MultiSelectDropdown";

export type { MultiSelectOption } from "./MultiSelectDropdown";
export default MultiSelectDropdown;
